import enTranslations from './en';
import noTranslations from './no';
import plTranslations from './pl';
import ruTranslations from './ru';
import _ from 'lodash';
import isWindow from 'components/common/helpers/isWindow';

class TransHelper {

  static translateRoute(locale, transKey, params = {}) {
    if (!locale) {
      throw "locale not passed!";
    }
    var pathTranslated = TransHelper.translate(locale, transKey);
    for (var key in params) {
      var value = params[key];
      pathTranslated = pathTranslated.replace(':' + key, value);
    }
    return pathTranslated.replace(":locale", locale);
  }

  static redirect(props, transKey, params = {}, locale = null) {
    if (!props.history) {
      throw "props.history not passed!";
    }
    if (!props.locale && !locale) {
      throw "locale not passed!";
    }
    if (props.locale) {
      var lang = props.locale;
    } else {
      var lang = locale;
    }
    var url = TransHelper.translateRoute(lang, transKey, params);
    props.history.push(url);
  }

  static getTrans = (translations, transKey) => {
    var results = _.at(translations, transKey);
    results = results[0];
    if (typeof results === "undefined" || results === '') {
      return transKey;
    } else {
      return results;
    }
  }

  static isTranslation = (locale, transKey) => {
    var results = _.at(TransHelper.getDictionary(locale), transKey);
    results = results[0];
    if (typeof results === "undefined") {
      return false;
    } else {
      return true;
    }
  }

  static findRouteTranslation = (currentlocale, newlocale, pathname) => {
    var routeKey = TransHelper.findRouteKey(currentlocale, pathname);
    if (routeKey) {
      var dictionary = TransHelper.getDictionary(newlocale);
      var path = dictionary["routes"]["url"][routeKey];
      path = path.replace(":locale", newlocale);
      return path;
    } else {
      return null;
    }
  }

  static findWholeRouteKey = (locale, pathname) => {
    var key = TransHelper.findRouteKey(locale, pathname);
    if (key) {
      return 'routes.url.' + key;
    } else {
      return null;
    }
  }

  static findRouteKey = (locale, pathname) => {
    var dictionary = TransHelper.getDictionary(locale);
    var urls = dictionary["routes"]["url"];
    if (urls) {
      for (var routeName in urls) {
        var dictionaryPath = urls[routeName];
        dictionaryPath = dictionaryPath.replace(":locale", locale);
        if (dictionaryPath === pathname) {
          return routeName;
        }
      }
    }
    return null;
  }

  static getDictionary = (locale) => {
    switch (locale) {
      case "en":
        return enTranslations;

      case "no":
        return noTranslations;

      case "pl":
        return plTranslations;

      case "ru":
        return ruTranslations;

      default:
        console.log("NOT FOUND DICTIONARY");
        return null;
    }
  }

  static isSameAsCurrentUrl = (locale, key, params) => {
    if (isWindow) {
      var url = TransHelper.translate(locale, key);
      url = url.replace(":locale", locale);
      return document.location.pathname === url;
    } else {
      return false;
    }
  }

  static translate = (locale, key, variables = null) => {
    if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
      if (locale === null || typeof locale === "undefined" || locale === '') {
        throw new Error("'locale' is not defined!");
      }
    }
    var transString = TransHelper.getTrans(TransHelper.getDictionary(locale), key);
    if (variables && variables.length !== 0) {
      Object.keys(variables).map((k) =>
        transString = transString.replace("%" + k + "%", variables[k])
      );
    }
    return transString;
  }

  static translateCurrentUrl = (newLocale, currentlocale, historyObj, locationObj) => {
    if (newLocale !== currentlocale) {
      var currentPath = locationObj.pathname;
      var newRoute = TransHelper.findRouteTranslation(currentlocale, newLocale, currentPath);
      if (newRoute != null && newRoute != "") {
        historyObj.replace(newRoute);
      }
    }
  }
}

export default TransHelper;
